export default {
  noData: 'Keine Daten für den Vergleich gefunden.',
};
